<div class="form-grid">
  <div class="group-container" *ngFor="let group of gridConfig?.groups">
    <div class="group-header">
      <h3>{{ group.title }}</h3>
    </div>
    <table class="group-table">
      <tbody>
        <tr *ngFor="let keyValue of group.keyValues">
          <td>
            <div class="key-cell">
              <span class="status-icon" *ngIf="keyValue.status" [ngClass]="{'success': keyValue.status === 'success', 'error': keyValue.status === 'error'}"></span>
              <span class="key">{{ keyValue.key }}</span>
            </div>
          </td>
          <td>
            <div class="value-cell">
              {{ keyValue.value }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
